<template>
    <client-page>
        <!-- S: 서브 비주얼 -->
        <template #subHead>
            <sub-visual id="about" title="About Us" src="/images/sub/subvisual-about.jpg"></sub-visual>
        </template>
        <!-- E: 서브 비주얼 -->

        <page-section id="about-vision" class="page-section--first grey darken-4 white--text">
            <template #title>
                <span class="font-secondary">Farming Tomorrow</span>
            </template>
            <template #text>
                <span class="white--text"><b class="primary--text">We work for an agricultural future together.</b> We are heading toward an agricultural future together.</span>
            </template>

            <div class="mb-60px mb-md-80px mb-lg-100px" data-aos="fade" data-aos-delay="100">
                <v-img max-width="300" :aspect-ratio="700 / 2020" src="/images/sub/about/about-img-mo-en.png" class="d-md-none mx-auto" />
                <v-img :aspect-ratio="1200 / 426" src="/images/sub/about/about-img-en.png" class="d-none d-md-block" />
            </div>

            <div data-aos="fade-up" data-aos-delay="100">
                <v-divider style="border-color: rgba(255,255,255,0.2);" />
                <v-row no-gutters align="center" justify="space-between">
                    <v-col cols="12" md="4">
                        <div class="px-12px pt-12px pb-4px px-md-40px py-md-36px px-lg-80px">
                            <div class="tit tit--xl font-secondary">Vision</div>
                        </div>
                    </v-col>
                    <v-col cols="12" md="8">
                        <div class="px-12px pb-12px px-md-40px py-md-36px px-lg-80px">
                            <p class="txt txt--xl white--text">We create an ecosystem to coexist with farmers and realize future sustainable agriculture by providing smart farm solutions.</p>
                        </div>
                    </v-col>
                </v-row>
            </div>

            <div data-aos="fade-up" data-aos-delay="200">
                <v-divider style="border-color: rgba(255,255,255,0.2);" />
                <v-row no-gutters align="center" justify="space-between">
                    <v-col cols="12" md="4">
                        <div class="px-12px pt-12px pb-4px px-md-40px py-md-36px px-lg-80px">
                            <div class="tit tit--xl font-secondary">Mission</div>
                        </div>
                    </v-col>
                    <v-col cols="12" md="8">
                        <div class="px-12px pb-12px px-md-40px py-md-36px px-lg-80px">
                            <p class="txt txt--xl white--text">We develop smart farm solutions that address future food shortages, minimize environmental pollution, and enhance agricultural productivity based on our cutting-edge technology and innovative ideas.</p>
                        </div>
                    </v-col>
                </v-row>
                <v-divider style="border-color: rgba(255,255,255,0.2);" />
            </div>
        </page-section>

        <page-section id="about-greeting" class="pb-0">
            <template #title>Greetings from the CEO</template>

            <v-row align="center">
                <v-col cols="12" md="5" data-aos="fade-left" data-aos-delay="100">
                    <v-card rounded="">
                        <v-img :max-width="$vuetify.breakpoint.mdAndUp ? 486 : 370" :aspect-ratio="486 / 534" src="/images/sub/about/greeting-img.jpg" class="mx-auto" />
                    </v-card>
                </v-col>
                <v-col cols="12" md="7" data-aos="fade-right" data-aos-delay="100">
                    <div class="pt-10px pt-md-0 pl-md-24px">
                        <div class="txt txt--xl txt--dark">
                            <p>IReis develops, manufactures, and supplies IT software solutions in keeping with the era of IT convergence. Since our establishment in September 2010, we have been doing our best for eco-friendly agriculture and development of high-efficiency energy solutions based on extensive, wide-ranging experience.</p>
                            <p>As an agricultural DX (digital transformation) expert that proactively responds to the rapidly changing IT convergence market both at home and abroad, we are making efforts to satisfy our clients through continuous changes and creative ideas and to evolve into a global leader. We are doing our best to create a transparent corporate culture by practicing ethical management based on gratitude, modesty, and boldness.</p>
                            <div class="mt-6px">
                                <v-row align="center" class="row--xs">
                                    <v-col cols="auto"><span class="txt--lg">IReis Co., Ltd., CEO</span></v-col>
                                    <v-col cols="auto"><b>Simon S.H. Jang</b></v-col>
                                    <!-- <v-col cols="auto"><v-img width="80" :aspect-ratio="80 / 50" src="/images/sub/about/greeting-img2.jpg"/></v-col> -->
                                </v-row>
                            </div>
                        </div>
                    </div>
                </v-col>
            </v-row>
        </page-section>

        <page-section id="about-history" class="pb-0">
            <template #title>History</template>

            <div data-aos="fade-up" data-aos-delay="100">
                <v-row no-gutters align="center">
                    <v-col cols="12" md="auto">
                        <div class="px-12px pt-12px pb-4px px-md-0 py-md-24px px-lg-60px">
                            <div class="w-md-180px tit tit--xl line-height-1 font-secondary grey--text text--darken-2">2023</div>
                        </div>
                    </v-col>
                    <v-col cols="12" md="">
                        <div class="px-12px pb-12px px-md-40px py-md-24px px-lg-60px">
                            <div>
                                <v-row class="row--xxs txt txt--xxl txt--dark line-height-15">
                                    <v-col cols="auto">·</v-col>
                                    <v-col>Opened Vertical Farm in Chuncheon Hanaro Mart</v-col>
                                </v-row>
                            </div>
                            <div class="pt-4px pt-md-8px">
                                <v-row class="row--xxs txt txt--xxl txt--dark line-height-15">
                                    <v-col cols="auto">·</v-col>
                                    <v-col>Developed AI solution of categorizing farms with similar climate conditions for growth environment standard</v-col>
                                </v-row>
                            </div>
                            <div class="pt-4px pt-md-8px">
                                <v-row class="row--xxs txt txt--xxl txt--dark line-height-15">
                                    <v-col cols="auto">·</v-col>
                                    <v-col>Registered as a construction business</v-col>
                                </v-row>
                            </div>
                            <div class="pt-4px pt-md-8px">
                                <v-row class="row--xxs txt txt--xxl txt--dark line-height-15">
                                    <v-col cols="auto">·</v-col>
                                    <v-col>Signed contract to supply 100 units of the medium water content measurement device(RMFarm) with MLED (Dubai) </v-col>
                                </v-row>
                            </div>
                        </div>
                    </v-col>
                </v-row>
                <v-divider class="grey lighten-3" />
            </div>
            <div data-aos="fade-up" data-aos-delay="100">
                <v-row no-gutters align="center">
                    <v-col cols="12" md="auto">
                        <div class="px-12px pt-12px pb-4px px-md-0 py-md-24px px-lg-60px">
                            <div class="w-md-180px tit tit--xl line-height-1 font-secondary grey--text text--darken-2">2022</div>
                        </div>
                    </v-col>
                    <v-col cols="12" md="">
                        <div class="px-12px pb-12px px-md-40px py-md-24px px-lg-60px">
                            <div>
                                <v-row class="row--xxs txt txt--xxl txt--dark line-height-15">
                                    <v-col cols="auto">·</v-col>
                                    <v-col>Medium water content measurement device (RMFarm) designated as an innovative product (Ministry of Agriculture, Food, and Rural Affairs)</v-col>
                                </v-row>
                            </div>
                            <div class="pt-4px pt-md-8px">
                                <v-row class="row--xxs txt txt--xxl txt--dark line-height-15">
                                    <v-col cols="auto">·</v-col>
                                    <v-col>Signed a business agreement for the expansion of low-carbon products with the Korea Foodservice Distributors Association</v-col>
                                </v-row>
                            </div>
                            <div class="pt-4px pt-md-8px">
                                <v-row class="row--xxs txt txt--xxl txt--dark line-height-15">
                                    <v-col cols="auto">·</v-col>
                                    <v-col>Selected as exemplary case of digital innovation</v-col>
                                </v-row>
                            </div>
                            <div class="pt-4px pt-md-8px">
                                <v-row class="row--xxs txt txt--xxl txt--dark line-height-15">
                                    <v-col cols="auto">·</v-col>
                                    <v-col>Selected as one of the best cases of support for data-based smart farm expansion</v-col>
                                </v-row>
                            </div>
                            <div class="pt-4px pt-md-8px">
                                <v-row class="row--xxs txt txt--xxl txt--dark line-height-15">
                                    <v-col cols="auto">·</v-col>
                                    <v-col>Established Farmire</v-col>
                                </v-row>
                            </div>
                        </div>
                    </v-col>
                </v-row>
                <v-divider class="grey lighten-3" />
            </div>
            <div data-aos="fade-up" data-aos-delay="100">
                <v-row no-gutters align="center">
                    <v-col cols="12" md="auto">
                        <div class="px-12px pt-12px pb-4px px-md-0 py-md-24px px-lg-60px">
                            <div class="w-md-180px tit tit--xl line-height-1 font-secondary grey--text text--darken-2">2021</div>
                        </div>
                    </v-col>
                    <v-col cols="12" md="">
                        <div class="px-12px pb-12px px-md-40px py-md-24px px-lg-60px">
                            <div>
                                <v-row class="row--xxs txt txt--xxl txt--dark line-height-15">
                                    <v-col cols="auto">·</v-col>
                                    <v-col>Certified as a business specializing in materials, components, and equipment</v-col>
                                </v-row>
                            </div>
                            <div class="pt-4px pt-md-8px">
                                <v-row class="row--xxs txt txt--xxl txt--dark line-height-15">
                                    <v-col cols="auto">·</v-col>
                                    <v-col>Received citation as an exemplary case of the new growth engine technology commercialization support project</v-col>
                                </v-row>
                            </div>
                        </div>
                    </v-col>
                </v-row>
                <v-divider class="grey lighten-3" />
            </div>
            <div data-aos="fade-up" data-aos-delay="100">
                <v-row no-gutters align="center">
                    <v-col cols="12" md="auto">
                        <div class="px-12px pt-12px pb-4px px-md-0 py-md-24px px-lg-60px">
                            <div class="w-md-180px tit tit--xl line-height-1 font-secondary grey--text text--darken-2">2020</div>
                        </div>
                    </v-col>
                    <v-col cols="12" md="">
                        <div class="px-12px pb-12px px-md-40px py-md-24px px-lg-60px">
                            <div>
                                <v-row class="row--xxs txt txt--xxl txt--dark line-height-15">
                                    <v-col cols="auto">·</v-col>
                                    <v-col>IReis CEO awarded the Minister’s Award by the Ministry of Science and ICT (in the AI and big data-based scientific technology category)</v-col>
                                </v-row>
                            </div>
                        </div>
                    </v-col>
                </v-row>
                <v-divider class="grey lighten-3" />
            </div>
            <div data-aos="fade-up" data-aos-delay="100">
                <v-row no-gutters align="center">
                    <v-col cols="12" md="auto">
                        <div class="px-12px pt-12px pb-4px px-md-0 py-md-24px px-lg-60px">
                            <div class="w-md-180px tit tit--xl line-height-1 font-secondary grey--text text--darken-2">2019</div>
                        </div>
                    </v-col>
                    <v-col cols="12" md="">
                        <div class="px-12px pb-12px px-md-40px py-md-24px px-lg-60px">
                            <div>
                                <v-row class="row--xxs txt txt--xxl txt--dark line-height-15">
                                    <v-col cols="auto">·</v-col>
                                    <v-col>Developed the all-in-one environmental control system based on data sensing of produce cultivated in soil</v-col>
                                </v-row>
                            </div>
                            <div class="pt-4px pt-md-8px">
                                <v-row class="row--xxs txt txt--xxl txt--dark line-height-15">
                                    <v-col cols="auto">·</v-col>
                                    <v-col>Awarded the Minister’s Award by the Ministry of Agriculture, Food, and Rural Affairs (in the scientific technology and distribution category)</v-col>
                                </v-row>
                            </div>
                        </div>
                    </v-col>
                </v-row>
                <v-divider class="grey lighten-3" />
            </div>
            <div data-aos="fade-up" data-aos-delay="100">
                <v-row no-gutters align="center">
                    <v-col cols="12" md="auto">
                        <div class="px-12px pt-12px pb-4px px-md-0 py-md-24px px-lg-60px">
                            <div class="w-md-180px tit tit--xl line-height-1 font-secondary grey--text text--darken-2">2018</div>
                        </div>
                    </v-col>
                    <v-col cols="12" md="">
                        <div class="px-12px pb-12px px-md-40px py-md-24px px-lg-60px">
                            <div>
                                <v-row class="row--xxs txt txt--xxl txt--dark line-height-15">
                                    <v-col cols="auto">·</v-col>
                                    <v-col>Developed the all-in-one irrigation control system based on machine learning of the environmental data of root zones</v-col>
                                </v-row>
                            </div>
                            <div class="pt-4px pt-md-8px">
                                <v-row class="row--xxs txt txt--xxl txt--dark line-height-15">
                                    <v-col cols="auto">·</v-col>
                                    <v-col>Developed the smart cultivation environment management system for the root zone management of hydroponic strawberries</v-col>
                                </v-row>
                            </div>
                        </div>
                    </v-col>
                </v-row>
                <v-divider class="grey lighten-3" />
            </div>
            <div data-aos="fade-up" data-aos-delay="100">
                <v-row no-gutters align="center">
                    <v-col cols="12" md="auto">
                        <div class="px-12px pt-12px pb-4px px-md-0 py-md-24px px-lg-60px">
                            <div class="w-md-180px tit tit--xl line-height-1 font-secondary grey--text text--darken-2">2017</div>
                        </div>
                    </v-col>
                    <v-col cols="12" md="">
                        <div class="px-12px pb-12px px-md-40px py-md-24px px-lg-60px">
                            <div>
                                <v-row class="row--xxs txt txt--xxl txt--dark line-height-15">
                                    <v-col cols="auto">·</v-col>
                                    <v-col>Developed the air and soil environment measurement system for a single greenhouse</v-col>
                                </v-row>
                            </div>
                            <div class="pt-4px pt-md-8px">
                                <v-row class="row--xxs txt txt--xxl txt--dark line-height-15">
                                    <v-col cols="auto">·</v-col>
                                    <v-col>Technical exchanges of the irrigation system with SENMATIC (Denmark)</v-col>
                                </v-row>
                            </div>
                        </div>
                    </v-col>
                </v-row>
                <v-divider class="grey lighten-3" />
            </div>
            <div data-aos="fade-up" data-aos-delay="100">
                <v-row no-gutters align="center">
                    <v-col cols="12" md="auto">
                        <div class="px-12px pt-12px pb-4px px-md-0 py-md-24px px-lg-60px">
                            <div class="w-md-180px tit tit--xl line-height-1 font-secondary grey--text text--darken-2">2014</div>
                        </div>
                    </v-col>
                    <v-col cols="12" md="">
                        <div class="px-12px pb-12px px-md-40px py-md-24px px-lg-60px">
                            <div>
                                <v-row class="row--xxs txt txt--xxl txt--dark line-height-15">
                                    <v-col cols="auto">·</v-col>
                                    <v-col>Signed MOU with VTT (Finland)</v-col>
                                </v-row>
                            </div>
                            <div class="pt-4px pt-md-8px">
                                <v-row class="row--xxs txt txt--xxl txt--dark line-height-15">
                                    <v-col cols="auto">·</v-col>
                                    <v-col>Developed the greenhouse cultivation energy consulting platform through ICBM-based energy unit technology combinations</v-col>
                                </v-row>
                            </div>
                        </div>
                    </v-col>
                </v-row>
                <v-divider class="grey lighten-3" />
            </div>
            <div data-aos="fade-up" data-aos-delay="100">
                <v-row no-gutters align="center">
                    <v-col cols="12" md="auto">
                        <div class="px-12px pt-12px pb-4px px-md-0 py-md-24px px-lg-60px">
                            <div class="w-md-180px tit tit--xl line-height-1 font-secondary grey--text text--darken-2">2013</div>
                        </div>
                    </v-col>
                    <v-col cols="12" md="">
                        <div class="px-12px pb-12px px-md-40px py-md-24px px-lg-60px">
                            <div>
                                <v-row class="row--xxs txt txt--xxl txt--dark line-height-15">
                                    <v-col cols="auto">·</v-col>
                                    <v-col>Developed the cultivation environment improvement system by measuring the water content of root zones in hydroponic facilities</v-col>
                                </v-row>
                            </div>
                            <div class="pt-4px pt-md-8px">
                                <v-row class="row--xxs txt txt--xxl txt--dark line-height-15">
                                    <v-col cols="auto">·</v-col>
                                    <v-col>Opened a bell pepper farm with the Gangneung Horticultural Export Association</v-col>
                                </v-row>
                            </div>
                        </div>
                    </v-col>
                </v-row>
                <v-divider class="grey lighten-3" />
            </div>
            <div data-aos="fade-up" data-aos-delay="100">
                <v-row no-gutters align="center">
                    <v-col cols="12" md="auto">
                        <div class="px-12px pt-12px pb-4px px-md-0 py-md-24px px-lg-60px">
                            <div class="w-md-180px tit tit--xl line-height-1 font-secondary grey--text text--darken-2">2012</div>
                        </div>
                    </v-col>
                    <v-col cols="12" md="">
                        <div class="px-12px pb-12px px-md-40px py-md-24px px-lg-60px">
                            <div>
                                <v-row class="row--xxs txt txt--xxl txt--dark line-height-15">
                                    <v-col cols="auto">·</v-col>
                                    <v-col>Working on EU RnD and FP7 in smart farms with FTK (Germany)</v-col>
                                </v-row>
                            </div>
                        </div>
                    </v-col>
                </v-row>
                <v-divider class="grey lighten-3" />
            </div>
            <div data-aos="fade-up" data-aos-delay="100">
                <v-row no-gutters align="center">
                    <v-col cols="12" md="auto">
                        <div class="px-12px pt-12px pb-4px px-md-0 py-md-24px px-lg-60px">
                            <div class="w-md-180px tit tit--xl line-height-1 font-secondary grey--text text--darken-2">2011</div>
                        </div>
                    </v-col>
                    <v-col cols="12" md="">
                        <div class="px-12px pb-12px px-md-40px py-md-24px px-lg-60px">
                            <div>
                                <v-row class="row--xxs txt txt--xxl txt--dark line-height-15">
                                    <v-col cols="auto">·</v-col>
                                    <v-col>Developed the integrated smart building energy monitoring system</v-col>
                                </v-row>
                            </div>
                            <div class="pt-4px pt-md-8px">
                                <v-row class="row--xxs txt txt--xxl txt--dark line-height-15">
                                    <v-col cols="auto">·</v-col>
                                    <v-col>Developed the system for monitoring the growth environment of higher value-added local specialties</v-col>
                                </v-row>
                            </div>
                            <div class="pt-4px pt-md-8px">
                                <v-row class="row--xxs txt txt--xxl txt--dark line-height-15">
                                    <v-col cols="auto">·</v-col>
                                    <v-col>Held business discussion on agricultural IT technology development with FTK (Germany)</v-col>
                                </v-row>
                            </div>
                        </div>
                    </v-col>
                </v-row>
                <v-divider class="grey lighten-3" />
            </div>
            <div data-aos="fade-up" data-aos-delay="100">
                <v-row no-gutters align="center">
                    <v-col cols="12" md="auto">
                        <div class="px-12px pt-12px pb-4px px-md-0 py-md-24px px-lg-60px">
                            <div class="w-md-180px tit tit--xl line-height-1 font-secondary grey--text text--darken-2">2010</div>
                        </div>
                    </v-col>
                    <v-col cols="12" md="">
                        <div class="px-12px pb-12px px-md-40px py-md-24px px-lg-60px">
                            <div>
                                <v-row class="row--xxs txt txt--xxl txt--dark line-height-15">
                                    <v-col cols="auto">·</v-col>
                                    <v-col>Held technical consultation on image analysis on crops with Fraunhofer IFF (Germany)</v-col>
                                </v-row>
                            </div>
                            <div class="pt-4px pt-md-8px">
                                <v-row class="row--xxs txt txt--xxl txt--dark line-height-15">
                                    <v-col cols="auto">·</v-col>
                                    <v-col>Developed the USN-based crop growth environment management system</v-col>
                                </v-row>
                            </div>
                            <div class="pt-4px pt-md-8px">
                                <v-row class="row--xxs txt txt--xxl txt--dark line-height-15">
                                    <v-col cols="auto">·</v-col>
                                    <v-col>Developed container system for plant growth</v-col>
                                </v-row>
                            </div>
                            <div class="pt-4px pt-md-8px">
                                <v-row class="row--xxs txt txt--xxl txt--dark line-height-15">
                                    <v-col cols="auto">·</v-col>
                                    <v-col>Established IReis Co., Ltd.</v-col>
                                </v-row>
                            </div>
                        </div>
                    </v-col>
                </v-row>
                <v-divider class="grey lighten-3" />
            </div>
        </page-section>

        <page-section id="about-cibi">
            <template #title>CI/BI</template>

            <page-section class="page-section--sm py-0">
                <template #pageSectionImmersive>
                    <div class="mb-20px mb-md-24px">
                        <h4 class="tit tit--lg" data-aos="fade-up" data-aos-delay="100">CI</h4>
                    </div>

                    <v-card outlined class="grey lighten-2" data-aos="fade" data-aos-delay="200">
                        <v-img :aspect-ratio="726 / 392" src="/images/sub/about/cibi-img-mo.jpg" class="d-md-none" />
                        <v-img :aspect-ratio="1198 / 330" src="/images/sub/about/cibi-img.jpg" class="d-none d-md-block" />
                    </v-card>
                </template>
            </page-section>

            <page-section class="page-section--sm pb-0">
                <template #pageSectionImmersive>
                    <div class="mb-20px mb-md-24px">
                        <h4 class="tit tit--lg" data-aos="fade-up" data-aos-delay="100">BI</h4>
                    </div>

                    <v-row>
                        <v-col cols="12" sm="6" md="3" data-aos="fade" data-aos-delay="100">
                            <v-card outlined class="grey lighten-2">
                                <v-img :aspect-ratio="282 / 206" src="/images/sub/about/cibi-img2.jpg" />
                            </v-card>
                            <div class="text-center mt-6px mt-md-16px">
                                <div class="txt txt--xl txt--dark">RMFarm</div>
                            </div>
                        </v-col>
                        <v-col cols="12" sm="6" md="3" data-aos="fade" data-aos-delay="200">
                            <v-card outlined class="grey lighten-2">
                                <v-img :aspect-ratio="282 / 206" src="/images/sub/about/cibi-img3.jpg" />
                            </v-card>
                            <div class="text-center mt-6px mt-md-16px">
                                <div class="txt txt--xl txt--dark">FarmingOn</div>
                            </div>
                        </v-col>
                        <v-col cols="12" sm="6" md="3" data-aos="fade" data-aos-delay="300">
                            <v-card outlined class="grey lighten-2">
                                <v-img :aspect-ratio="282 / 206" src="/images/sub/about/cibi-img4.jpg" />
                            </v-card>
                            <div class="text-center mt-6px mt-md-16px">
                                <div class="txt txt--xl txt--dark">FarmingOn2</div>
                            </div>
                        </v-col>
                        <v-col cols="12" sm="6" md="3" data-aos="fade" data-aos-delay="400">
                            <v-card outlined class="grey lighten-2">
                                <v-img :aspect-ratio="282 / 206" src="/images/sub/about/cibi-img5.jpg" />
                            </v-card>
                            <div class="text-center mt-6px mt-md-16px">
                                <div class="txt txt--xl txt--dark">FARMIRE</div>
                            </div>
                        </v-col>
                    </v-row>
                </template>
            </page-section>
        </page-section>

        <page-section id="about-technology" class="page-section--last grey darken-4 white--text">
            <template #title>Certificates</template>

            <div class="tabs-wrap">
                <v-tabs v-model="tab" hide-slider show-arrows centered center-active class="v-tabs--btn v-tabs--dark">
                    <u-tab to="#about-patent" id="about-patent">Patents</u-tab>
                    <u-tab to="#about-certification" id="about-certification">Certificates</u-tab>
                    <u-tab to="#about-trademark" id="about-trademark">Trademark</u-tab>
                    <u-tab to="#about-design" id="about-design">Design</u-tab>
                    <u-tab to="#about-award" id="about-award">Awards/Appointment Letter</u-tab>
                </v-tabs>
            </div>

            <v-tabs-items v-model="tab">
                <v-tab-item value="about-patent" transition="fade-transition" reverse-transition="fade-transition">
                    <v-row class="row-cols-lg-5">
                        <v-col cols="6" sm="4" md="3">
                            <v-card rounded="">
                                <v-img max-width="220" :aspect-ratio="220 / 310" src="/images/sub/about/patent-img.jpg" />
                            </v-card>
                        </v-col>
                        <v-col cols="6" sm="4" md="3">
                            <v-card rounded="">
                                <v-img max-width="220" :aspect-ratio="220 / 310" src="/images/sub/about/patent-img2.jpg" />
                            </v-card>
                        </v-col>
                        <v-col cols="6" sm="4" md="3">
                            <v-card rounded="">
                                <v-img max-width="220" :aspect-ratio="220 / 310" src="/images/sub/about/patent-img3.jpg" />
                            </v-card>
                        </v-col>
                        <v-col cols="6" sm="4" md="3">
                            <v-card rounded="">
                                <v-img max-width="220" :aspect-ratio="220 / 310" src="/images/sub/about/patent-img4.jpg" />
                            </v-card>
                        </v-col>
                        <v-col cols="6" sm="4" md="3">
                            <v-card rounded="">
                                <v-img max-width="220" :aspect-ratio="220 / 310" src="/images/sub/about/patent-img5.jpg" />
                            </v-card>
                        </v-col>
                        <v-col cols="6" sm="4" md="3">
                            <v-card rounded="">
                                <v-img max-width="220" :aspect-ratio="220 / 310" src="/images/sub/about/patent-img6.jpg" />
                            </v-card>
                        </v-col>
                        <v-col cols="6" sm="4" md="3">
                            <v-card rounded="">
                                <v-img max-width="220" :aspect-ratio="220 / 310" src="/images/sub/about/patent-img7.jpg" />
                            </v-card>
                        </v-col>
                        <v-col cols="6" sm="4" md="3">
                            <v-card rounded="">
                                <v-img max-width="220" :aspect-ratio="220 / 310" src="/images/sub/about/patent-img8.jpg" />
                            </v-card>
                        </v-col>
                        <v-col cols="6" sm="4" md="3">
                            <v-card rounded="">
                                <v-img max-width="220" :aspect-ratio="220 / 310" src="/images/sub/about/patent-img9.jpg" />
                            </v-card>
                        </v-col>
                        <v-col cols="6" sm="4" md="3">
                            <v-card rounded="">
                                <v-img max-width="220" :aspect-ratio="220 / 310" src="/images/sub/about/patent-img10.jpg" />
                            </v-card>
                        </v-col>
                    </v-row>
                </v-tab-item>
                <v-tab-item value="about-certification" transition="fade-transition" reverse-transition="fade-transition">
                    <v-row class="row-cols-lg-5">
                        <v-col cols="6" sm="4" md="3">
                            <v-card rounded="">
                                <v-img max-width="220" :aspect-ratio="220 / 310" src="/images/sub/about/certification-img.jpg" />
                            </v-card>
                        </v-col>
                        <v-col cols="6" sm="4" md="3">
                            <v-card rounded="">
                                <v-img max-width="220" :aspect-ratio="220 / 310" src="/images/sub/about/certification-img2.jpg" />
                            </v-card>
                        </v-col>
                        <v-col cols="6" sm="4" md="3">
                            <v-card rounded="">
                                <v-img max-width="220" :aspect-ratio="220 / 310" src="/images/sub/about/certification-img3.jpg" />
                            </v-card>
                        </v-col>
                        <v-col cols="6" sm="4" md="3">
                            <v-card rounded="">
                                <v-img max-width="220" :aspect-ratio="220 / 310" src="/images/sub/about/certification-img4.jpg" />
                            </v-card>
                        </v-col>
                        <v-col cols="6" sm="4" md="3">
                            <v-card rounded="">
                                <v-img max-width="220" :aspect-ratio="220 / 310" src="/images/sub/about/certification-img5.jpg" />
                            </v-card>
                        </v-col>
                        <v-col cols="6" sm="4" md="3">
                            <v-card rounded="">
                                <v-img max-width="220" :aspect-ratio="220 / 310" src="/images/sub/about/certification-img6.jpg" />
                            </v-card>
                        </v-col>
                        <v-col cols="6" sm="4" md="3">
                            <v-card rounded="">
                                <v-img max-width="220" :aspect-ratio="220 / 310" src="/images/sub/about/certification-img7.jpg" />
                            </v-card>
                        </v-col>
                    </v-row>
                </v-tab-item>
                <v-tab-item value="about-trademark" transition="fade-transition" reverse-transition="fade-transition">
                    <v-row class="row-cols-lg-5">
                        <v-col cols="6" sm="4" md="3">
                            <v-card rounded="">
                                <v-img max-width="220" :aspect-ratio="220 / 310" src="/images/sub/about/trademark-img.jpg" />
                            </v-card>
                        </v-col>
                        <v-col cols="6" sm="4" md="3">
                            <v-card rounded="">
                                <v-img max-width="220" :aspect-ratio="220 / 310" src="/images/sub/about/trademark-img2.jpg" />
                            </v-card>
                        </v-col>
                        <v-col cols="6" sm="4" md="3">
                            <v-card rounded="">
                                <v-img max-width="220" :aspect-ratio="220 / 310" src="/images/sub/about/trademark-img3.jpg" />
                            </v-card>
                        </v-col>
                        <v-col cols="6" sm="4" md="3">
                            <v-card rounded="">
                                <v-img max-width="220" :aspect-ratio="220 / 310" src="/images/sub/about/trademark-img4.jpg" />
                            </v-card>
                        </v-col>
                        <v-col cols="6" sm="4" md="3">
                            <v-card rounded="">
                                <v-img max-width="220" :aspect-ratio="220 / 310" src="/images/sub/about/trademark-img5.jpg" />
                            </v-card>
                        </v-col>
                        <v-col cols="6" sm="4" md="3">
                            <v-card rounded="">
                                <v-img max-width="220" :aspect-ratio="220 / 310" src="/images/sub/about/trademark-img6.jpg" />
                            </v-card>
                        </v-col>
                        <v-col cols="6" sm="4" md="3">
                            <v-card rounded="">
                                <v-img max-width="220" :aspect-ratio="220 / 310" src="/images/sub/about/trademark-img7.jpg" />
                            </v-card>
                        </v-col>
                        <v-col cols="6" sm="4" md="3">
                            <v-card rounded="">
                                <v-img max-width="220" :aspect-ratio="220 / 310" src="/images/sub/about/trademark-img8.jpg" />
                            </v-card>
                        </v-col>
                    </v-row>
                </v-tab-item>
                <v-tab-item value="about-design" transition="fade-transition" reverse-transition="fade-transition">
                    <v-row class="row-cols-lg-5">
                        <v-col cols="6" sm="4" md="3">
                            <v-card rounded="">
                                <v-img max-width="220" :aspect-ratio="220 / 310" src="/images/sub/about/design-img.jpg" />
                            </v-card>
                        </v-col>
                        <v-col cols="6" sm="4" md="3">
                            <v-card rounded="">
                                <v-img max-width="220" :aspect-ratio="220 / 310" src="/images/sub/about/design-img2.jpg" />
                            </v-card>
                        </v-col>
                        <v-col cols="6" sm="4" md="3">
                            <v-card rounded="">
                                <v-img max-width="220" :aspect-ratio="220 / 310" src="/images/sub/about/design-img3.jpg" />
                            </v-card>
                        </v-col>
                    </v-row>
                </v-tab-item>
                <v-tab-item value="about-award" transition="fade-transition" reverse-transition="fade-transition">
                    <v-row class="row-cols-lg-5">
                        <v-col cols="6" sm="4" md="3">
                            <v-card rounded="">
                                <v-img max-width="220" :aspect-ratio="220 / 310" src="/images/sub/about/award-img.jpg" />
                            </v-card>
                        </v-col>
                        <v-col cols="6" sm="4" md="3">
                            <v-card rounded="">
                                <v-img max-width="220" :aspect-ratio="220 / 310" src="/images/sub/about/award-img2.jpg" />
                            </v-card>
                        </v-col>
                        <v-col cols="6" sm="4" md="3">
                            <v-card rounded="">
                                <v-img max-width="220" :aspect-ratio="220 / 310" src="/images/sub/about/award-img3.jpg" />
                            </v-card>
                        </v-col>
                        <v-col cols="6" sm="4" md="3">
                            <v-card rounded="">
                                <v-img max-width="220" :aspect-ratio="220 / 310" src="/images/sub/about/award-img4.jpg" />
                            </v-card>
                        </v-col>
                        <v-col cols="6" sm="4" md="3">
                            <v-card rounded="">
                                <v-img max-width="220" :aspect-ratio="220 / 310" src="/images/sub/about/award-img5.jpg" />
                            </v-card>
                        </v-col>
                        <v-col cols="6" sm="4" md="3">
                            <v-card rounded="">
                                <v-img max-width="220" :aspect-ratio="220 / 310" src="/images/sub/about/award-img6.jpg" />
                            </v-card>
                        </v-col>
                    </v-row>
                </v-tab-item>
            </v-tabs-items>
        </page-section>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/en/templates/ClientPage.vue";
import SubVisual from "@/components/client/sub/sub-visual.vue";
import PageSection from "@/pages/client/templates/page-section.vue";
import UTabs from "@/components/dumb/u-tabs.vue";
import UTab from "@/components/dumb/u-tab.vue";

export default {
    components: {
        ClientPage,
        SubVisual,
        PageSection,
        UTabs,
        UTab,
    },
    props: {},
    data() {
        return {
            tab: null,
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            this.$nextTick(() => {});
        },
    },
};
</script>

<style lang="scss" scoped></style>
